package horcrux.common.extensions

import arrow.core.Either
import arrow.core.NonEmptyList
import arrow.core.left
import arrow.core.right
import arrow.core.toNonEmptyListOrNull

fun <A> List<A>.toNonEmptyList(): Either<Throwable, NonEmptyList<A>> =
    this.toNonEmptyListOrNull()?.right()
        ?: IllegalStateException("Attempted to convert empty list to NonEmptyList").left()

fun <A> NonEmptyList<A>.replaceAt(index: Int, newValue: A): NonEmptyList<A> {
    require(index in 0 until this.size) { "Index out of bounds" }

    val newList = this.all.toMutableList().apply {
        this[index] = newValue
    }

    return newList.toNonEmptyListOrNull() ?: run {
        error("Resultant list was unexpectedly empty")
    }
}

fun <A> NonEmptyList<A>.replaceLast(newValue: A): NonEmptyList<A> = replaceAt(this.size - 1, newValue)

fun <A> NonEmptyList<A>.removeAtIndex(index: Int): NonEmptyList<A> {
    require(index in 0 until this.size) { "Index out of bounds" }

    val newList = this.all.toMutableList().apply {
        removeAt(index)
    }

    return newList.toNonEmptyListOrNull() ?: run {
        error("Removing element results in an empty list")
    }
}

fun <A, B> List<A>.product(other: List<B>): List<Pair<A, B>> =
    this.flatMap { a -> other.map { b -> a to b } }
